import React, {Component} from 'react';

export default class OrderItem extends Component {
    render() {
        return (
            <div>
                {this.props.item ? this.props.item.name : 'Удалённый товар'}
            </div>
        );
    }
}